export const en = {
    'chat-not-found': 'No chat with this ID exists',
    'text-error': 'An unexpected error occurred while adding the chat. Try again later.'
};
